<div class="d-flex row-cols-12">
    <div class="col-7 mt-0">
        <h3 class="title float-start" translate="Settings.OrganisationSection.Title"></h3>
    </div>
    <!-- <div class="col-5 text-end">
        <button class="btn btn-sm btn-secondary mt-2 mb-2 me-4" *ngIf="user !== undefined && (user.isSystemAdmin || user.isWhitelabelAdmin)" (click)="changeOrganisation()" translate>Button.ChangeOrganisation</button>
    </div> -->
</div>
<div class="px-4 pt-1 pb-4">
    <form [formGroup]="form" (ngSubmit)="updateKvk()">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
            <label for="InputOrganisationID" class="form-label" translate="Settings.OrganisationSection.ID"><app-info-button labelName="Settings.OrganisationSection.OrganisationIDTooltip"></app-info-button></label>
        </div>
        <div class="col-12 mb-3">
            <button class="btn btn-sm default dropdown-toggle text-truncate authenticatorSecret d-block breakingRecoveryCodesButton" type="button" id="dropdownMenu">
                <span class="d-block breakingRecoveryCodes">
                    <em class="bi bi-files float-end" aria-hidden="true" (click)="copyOrganisationIdToClipboard()"></em>  
                    {{selectedOrganisationId}}
                </span>
            </button>
        </div>
        <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
            <label for="kvk" class="form-label" translate="Settings.OrganisationSection.KVK"><app-info-button labelName="Settings.OrganisationSection.KVKTooltip"></app-info-button></label>
            <input type="text" maxlength="8" class="form-control" id="kvk" formControlName="kvk" (keyup)="updateAttribute('kvk', $event)" (focusout)="updateAttribute('kvk', $event)" [value]="organisation?.kvk">
            <app-formcontrol-error-messages [forControl]="kvkNumberControl"></app-formcontrol-error-messages>
        </div>
        <div class="mb-3 col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mt-4 text-end">
            <button type="submit" id="buttonSave" class="btn btn-sm btn-primary mb-3" translate="Button.SaveChanges"></button>
        </div>
        <div class="w-auto row row-cols-12">
            <div class="col-6">
                <div class="mb-2" translate="Settings.OrganisationSection.Credits"></div>
                <app-settingsProgressBlock [TopLeft]="'Total'" [TopRight]="'Remaining'" [BottomLeft]="signatureAmount" [BottomRight]="remainingSignatures" [Progress]="signatureProgress" ></app-settingsProgressBlock>
            </div>
            <div class="col-6">
                <div class="mb-2" translate="Settings.OrganisationSection.Licenses"></div>
                <app-settingsProgressBlock [TopLeft]="'Available'" [TopRight]="'Activated'" [BottomLeft]="organisation?.organisation?.maxUserCount" [BottomRight]="userCount" [Progress]="(userCount/organisation?.organisation?.maxUserCount)*100" ></app-settingsProgressBlock>
            </div>
            <div class="row p-4 col-12">
                <span translate="Settings.OrganisationSection.Usage"></span>
            </div>
        </div>
    </form>
    <app-organisation-signing-chart></app-organisation-signing-chart>
</div>